import React, { Component } from 'react';
import { Trans, translate } from 'react-i18next';
import Medal from '../../components/Medal'
import Tag from '../../components/Tag'
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

const URI_VENTA_EN_LINEA = process.env.REACT_APP_URI_VENTA_EN_LINEA;

class CoworkCard extends Component {
    handleClickReserve(event, id) {
        event.stopPropagation();
        this.props.history.push(`${URI_VENTA_EN_LINEA}/cowork/coworkedpayment/${id}`)
    }

    handleClickInfo(id) {
        this.props.history.push(`${URI_VENTA_EN_LINEA}/cowork-info/${id}`);
    }

    render() {
        const { t } = this.props;
        const coworks = this.props.coworks;
        const urlimg = "https://api.iosoffices.com/apiosfera/v4/src/uploads/cowork_imagenes/";
        return (
            <div className="list-card-resvations" >
                <div className="list-card-panel-seccion">
                    <div className="content-card-panel-seccion">
                        <div className="list grid-2">
                            {coworks.map((cowork) => (
                                <div
                                    className="col-xs-12 col-sm-6 col-md-6 card-panel-rooms"
                                    key={cowork.id}
                                    onClick={() => this.handleClickInfo(cowork.id)}>
                                    <div className="card-panel panel panel-default card">
                                        <div className="panel-heading">
                                            <img className="background-img" src={urlimg + cowork.id} alt="Fondo" />
                                            <Medal type={cowork.coworks_clasificacion} />
                                        </div>
                                        <article className="card-panel-body">
                                            <div className="panel-body-title">
                                                <h4 className="ioscentro">{cowork.centro_name.toUpperCase()}</h4>
                                            </div>
                                            <div className="panel-body-description">
                                                <div className="panel-description-text">
                                                    {'  '}{cowork.centro_direccion}, {cowork.centro_ciudad}
                                                    {', '}{cowork.centro_estado}, {cowork.centro_cp}
                                                </div>
                                                <div className="panel-description-information">
                                                    <div className="contenedor-flexbox">
                                                        <Tag
                                                            isBigTag
                                                            icon='dollar-sign'
                                                            text="Precio por mes:"
                                                            value={`${cowork.precio} ${cowork.moneda_id === 1 ? 'MXN' : 'USD'}`}
                                                        />
                                                        {
                                                            cowork.coworks_clasificacion === 'Plus' &&
                                                            <Tag
                                                                isBigTag
                                                                alt
                                                                icon='star'
                                                                text={t('venta_linea.reservation_tags.beneficio_plus_title')}
                                                                value={t('venta_linea.reservation_tags.beneficio_plus_description')}
                                                            />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="panel-body-bottom">
                                                <button
                                                    onClick={(e) => this.handleClickReserve(e, cowork.id)}
                                                    className="btn btn-block btn-primary"
                                                    type="button">
                                                    <Trans>venta_linea.index.cowork.reserve</Trans>
                                                </button>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(
    withRouter,
    translate('common')
)(CoworkCard);



// WEBPACK FOOTER //
// ./src/store/Cowork/CoworkCard.js